import React from 'react';
import InputMask from 'react-input-mask';
import { Link } from "react-router-dom";

//________________________//

import * as data from "../utils/constants.js";
import { priceList2, arcPrice, windowsillPrice, tidePrice, installationPrice, slopePrices, keff } from "../utils/priceList.js";

//________________________//

function App() {
  const [form, setForm] = React.useState(0);

  const [isWindow, setIsWindow] = React.useState(1);
  const [type, setType] = React.useState(0);

  const [messageSuccess, setMessageSuccess] = React.useState(false);
  const [messageFailed, setMessageFailed] = React.useState(false);
  const [isSended, setIsSended] = React.useState(false);

  const [arc, setArc] = React.useState(0);
  const [option, setOption] = React.useState(0);
  const [isProfile, setIsProfile] = React.useState(false); const [profile, setProfile] = React.useState(0);
  const [width, setWidth] = React.useState(0);
  const [height, setHeight] = React.useState(0);

  const [isWindowsill, setIsWindowsill] = React.useState(false);
  const [isTide, setIsTide] = React.useState(false);
  const [isInstallation, setIsInstallation] = React.useState(false);
  const [isSlope, setIsSlope] = React.useState(false);

  const [time, setTime] = React.useState(3);
  const [isTimer, setIsTimer] = React.useState(false);
  const timerRef = React.useRef(null);

  const formRef = React.useRef(null);
  const userRef = React.useRef(null);
  const blockPS = React.useRef(null);
  const blockWS = React.useRef(null);
  const blockHS = React.useRef(null);

  const [isPSOpened, setIsPSOpened] = React.useState(false);
  const [isWSOpened, setIsWSOpened] = React.useState(false);
  const [isHSOpened, setIsHSOpened] = React.useState(false);

  const [price, setPrice] = React.useState(0.00);

  function genPSelect(){ setIsPSOpened(!isPSOpened); setIsHSOpened(false); setIsWSOpened(false); }
  function genWSelect(){ setIsWSOpened(!isWSOpened); setIsHSOpened(false); setIsPSOpened(false); }
  function genHSelect(){ setIsHSOpened(!isHSOpened); setIsWSOpened(false); setIsPSOpened(false); }

  React.useEffect(() => {
    if (window.innerWidth < 1024) setForm(-1);
  }, []);

  React.useEffect(() => {
    const handleNotOn = e => {
      if(!isWSOpened && !isHSOpened && !isPSOpened) return;
      if(!blockWS.current && !blockHS.current && !blockPS.current) return;
      if(!blockWS.current.contains(e.target) && !blockHS.current.contains(e.target) && !blockPS.current.contains(e.target)){
        setIsPSOpened(false);
        setIsWSOpened(false);
        setIsHSOpened(false);
      }
    }

    const handleKey = e => {
      if(e.keyCode === 27){
        setIsPSOpened(false);
        setIsWSOpened(false);
        setIsHSOpened(false);
      }
    }

    document.addEventListener("click", handleNotOn);
    document.addEventListener("keyup", handleKey);
    return () => { 
      document.removeEventListener("click", handleNotOn);
      document.removeEventListener("keyup", handleKey);
    }
  }, [isWSOpened, isHSOpened, isPSOpened])

  React.useEffect(() => {
    var add = 0

    var nW = data.widths[isWindow][type][option][width]/1000;
    var nH = data.heights[isWindow][type][option][height]/1000;

    if(isWindow){
      add += data.opensA[isWindow][type][option]*arcPrice[arc];
      if(isWindowsill) add += nW*windowsillPrice;
      if(isTide) add += nW*tidePrice;
      if(isSlope) add += slopePrices[type];
    }

    if(isInstallation) {
      if(isWindow) add += nW*nH*installationPrice;
      else {
        if(data.opensA[isWindow][type][option] === 1) add += 80;
        if(data.opensA[isWindow][type][option] === 2) add += 130;
      }
    }

    var newPrice = priceList2[isWindow][profile][type][option][height][width];
    newPrice = newPrice * ((100+keff.plus)/100);
    newPrice = newPrice * ((100-keff.minus)/100);

    newPrice += add;

    newPrice = Math.ceil(newPrice);

    if(isNaN(newPrice)){
      setPrice("Недоступно");
      console.log(add);
    }
    else setPrice(newPrice);
  }, [isWindow, type, arc, option, profile, width, height, isWindowsill, isTide, isInstallation, isSlope])

  function toZero(i){
    setIsWindowsill(false);
    setIsTide(false);
    setIsInstallation(false);
    setIsSlope(false);
    setArc(0);
    setOption(0);

    if(i === 5){
      setIsWindowsill(false);
      setIsTide(false);
    }

    if(i >= 10){
      if(isWindow){
        setIsProfile(false);
        setProfile(0);
      }
      setIsWindow(0);
      setType(i-10);
    } else {
      if(!isWindow){
        setIsProfile(false);
        setProfile(0);
      }
      setIsWindow(1);
      setType(i);
    }

    setWidth(0);
    setHeight(0);
  }

  function rePos(o, p){
    var iW = 0;
    var iH = 0;

    var isW = data.widths[isWindow][type][o].includes(data.widths[isWindow][type][option][width]);
    var isH = data.heights[isWindow][type][o].includes(data.heights[isWindow][type][option][height]);


    if(isW) iW = data.widths[isWindow][type][o].indexOf(data.widths[isWindow][type][option][width]);
    if(isH) iH = data.heights[isWindow][type][o].indexOf(data.heights[isWindow][type][option][height]);

    if(priceList2[isWindow][p][type][o][iH][iW] === -1){
      iW = 0;
      iH = 0;

      while(priceList2[isWindow][p][type][o][iH][iW] === -1){
        if(iW+1 === data.widths[isWindow][type][o].length){
          iW = -1;
          iH++;
        }
        iW++;
      }

      blockWS.current.style.background = "rgba(235, 76, 66, 0.5)";
      blockWS.current.style.borderBottom = "2px solid rgba(235, 76, 66, 1)";
      blockHS.current.style.background = "rgba(235, 76, 66, 0.5)";
      blockHS.current.style.borderBottom = "2px solid rgba(235, 76, 66, 1)";
    }

    if(!isW){
      blockWS.current.style.background = "rgba(235, 76, 66, 0.5)";
      blockWS.current.style.borderBottom = "2px solid rgba(235, 76, 66, 1)";
    }
    if(!isH){
      blockHS.current.style.background = "rgba(235, 76, 66, 0.5)";
      blockHS.current.style.borderBottom = "2px solid rgba(235, 76, 66, 1)";
    }

    setTimeout(() => {
      blockWS.current.style.background = "#F8F9FA";
      blockWS.current.style.borderBottom = "2px solid #bbb";
      blockHS.current.style.background = "#F8F9FA";
      blockHS.current.style.borderBottom = "2px solid #bbb";
    }, 300);

    setWidth(iW);
    setHeight(iH);

    setOption(o);
    setProfile(p);
  }

  function startTimer(toTime){
    if(!isTimer){
      let tempTime = time;
      const timer = setInterval(() => {
        tempTime = tempTime-1;
        setTime(tempTime);

        if(tempTime < 1){
          window.close();
          clearInterval(timer);
        }
      }, 1000);

      setIsTimer(true);
    }
  }

  function sendTG(){
    var nW = data.widths[isWindow][type][option][width]/1000;
    var nH = data.heights[isWindow][type][option][height]/1000;

    let formData = "";
    formData += "Заявка с oknagomel.by";
    formData += "%0A%0AИмя: " + userRef.current.children[0].value;
    formData += "%0AТелефон: " + userRef.current.children[1].value;

    if(isWindow) formData += "%0A%0AТип: " + data.windowNames[type];
    else formData += "%0A%0AТип: " + data.doorNames[type];

    if(isWindow) formData += "%0AСтворки: " + data.optionNames[isWindow][type][option];

    formData += "%0AПрофиль: " + data.profiles[isWindow][profile];
    formData += "%0AШирина: " + data.widths[isWindow][type][option][width];
    formData += "%0AВысота: " + data.heights[isWindow][type][option][height];

   if(isWindow){
    formData += "%0A%0AФурнитура: " + data.arcNames[arc] + " (" + Math.ceil(data.opensA[isWindow][type][option]*arcPrice[arc]) + "руб.)";
    formData += "%0AПодоконник - " + (isWindowsill ? "да" : "нет") + " (" + Math.ceil(nW*windowsillPrice*isWindowsill) + "руб.)";
    formData += "%0AОтлив - " + (isTide ? "да" : "нет") + " (" + Math.ceil(nW*tidePrice*isTide) + "руб.)";
    formData += "%0AОткосы - " + (isSlope ? "да" : "нет") + " (" + Math.ceil(slopePrices[type]*isSlope) + "руб.)";
   }

    formData += "%0AМонтаж - " + (isInstallation ? "да" : "нет") + " (" + Math.ceil(nW*nH*installationPrice*isInstallation) + "руб.)";

    formData += "%0A%0AЦена: " + price + "руб.";

    for(let i = 0; i < data.chatId.length; i++){
      fetch(`https://api.telegram.org/bot${data.HTTPBot}/sendMessage?chat_id=${data.chatId[i]}&text=${formData}`, {
        method : 'POST',
        headers : { 'Content-Type': 'application/json' }
      }).then(() => {
        setMessageSuccess(true);
        setIsSended(true);

        startTimer()
      }).catch(() => {
        setMessageFailed(true);
        setIsSended(false);
      })
    }
  }

  function handleSend(event){
    event.preventDefault();

    let nameV = true;
    let telV = true;

    if(userRef.current.children[0].value.length < 2){
      nameV = false;
      userRef.current.children[0].style.paddingLeft = "25px";
      setTimeout(() => { userRef.current.children[0].style.paddingLeft = "10px"; }, 200)
    }

    if(userRef.current.children[1].value.length < 19){
      telV = false;
      userRef.current.children[1].style.paddingLeft = "25px";
      setTimeout(() => { userRef.current.children[1].style.paddingLeft = "10px"; }, 200)
    }

    if(nameV && telV) { sendTG(); }
  }

  function openOnMob(t){
    toZero(t);
    setForm(0);

    formRef.current.style.zIndex = "10";
    formRef.current.style.display = "flex";
  }
  function closeOnMob(){
    setForm(-1);
    formRef.current.style.zIndex = "0";
    formRef.current.style.display = "none";
  }
  
  return (
    <div className="App">
      <section className="block">
        <div className="block__con">
          <h3 className="block__title">Калькулятор</h3>
          <p className="block__text">Вы можете воспользоваться калькулятором и сами рассчитать стоимость ваших новых окон ПВХ. Обратите внимание, что точный расчет цены осуществляется после замера, который осуществляется нашим специалистом.</p>
          <div className="block__main">
            <div className="block__column" style={{display: ((form !== -1 && window.innerWidth < 1024) ? "none" : "grid") }}>
              <h3 className="block__name">Окна ПВХ</h3>
              <div className="block__types">
                {
                  data.windowNames.map((name, i) => {
                    return ( 
                      <div className={`block__type ${type === i && isWindow ? "block__type-active" : ""}`} onClick={() => openOnMob(i)} key={i}> 
                        <img alt={name} src={data.oImages[i]} />
                        <p>{name}</p>
                      </div> 
                    )
                  })
                }
              </div>
              <h3 className="block__name" style={{marginTop: "40px"}}>Двери ПВХ</h3>
              <div className="block__types">
                {
                  data.doorNames.map((name, i) => {
                    return ( 
                      <div className={`block__type ${type === i && !isWindow ? "block__type-active" : ""}`} onClick={() => openOnMob(i+10)} key={i+data.windowNames.length}> 
                        <img alt={name} src={data.oImages[i+data.windowNames.length]} />
                        <p>{name}</p>
                      </div> 
                    )
                  })
                }
              </div>
            </div>

            <div style={{display: "block"}}>
              <div className="calc" ref={formRef} style={{maxHeight: (form ? "700px" : (isWindow ? "1200px" : "850px"))}}>
                <div className="calc__price-block-out">
                  <div className="calc__cross calc__cross-1" style={{display: (form === 1 ? "none" : "")}} onClick={() => closeOnMob()}></div>
                  <div className="calc__cross" style={{display: (form === 0 ? "none" : "")}} onClick={() => { setForm(0) }}></div>
                  <div className="calc__price-block">
                    <div className="calc__price-window">
                      <p>{(isProfile ? price : 0)}<span style={{fontSize: "22px", lineHeight: "22px", marginLeft: "10px", letterSpacing: "1px"}}>руб</span></p>
                    </div>
                  </div>
                </div>
                {
                  (form === 0) ? (
                    <>
                      <form className="calc__form">
                        <div>
                          <div className="calc__types">
                            {
                              data.images[isWindow][type].map((img, i) => {
                                return ( 
                                  <div 
                                    key={i}
                                    onClick={() => { rePos(i, profile) }}
                                    className={option === i ? "calc__type-active" : ""}
                                    
                                  >
                                    <img src={img} alt="" style={{maxHeight: (type === 2 ? "130px" : "140px")}} />
                                    {
                                      (isWindow && type !== 5) ? (
                                        <p>{(data.opensA[isWindow][type][i] === 0 ? "Глухое" : "Поворотно-откидное")}</p>
                                      ) : (<></>)
                                    }
                                  </div>
                                )
                              })
                            }
                          </div>
                        </div>

                        <div style={{borderTop: "2px dashed #D7DFE7", padding: "20px 0 15px"}}>
                          <div className={`calc__select calc__select-1 ${isPSOpened ? "calc__select_active calc__select-1_active" : ""}`} onClick={() => genPSelect()} ref={blockPS}>
                            <p style={{opacity: isProfile ? "1" : "0.5"}}>{isProfile ? data.profiles[isWindow][profile] : "Выберите профиль"}</p>
                            <ul className="calc__select-block" style={{zIndex: 3}}>
                              {
                                data.profiles[isWindow].map((p, i) => {
                                  return ( <li key={i} className="calc__select-option" onClick={() => {rePos(option, i); setIsProfile(true)}}>{p}</li> )
                                })
                              }
                            </ul>
                          </div>
                          <Link 
                            to={isProfile ? data.profileLinks[isWindow][profile] : ""}
                            className={`calc__profile-info ${isProfile ? "" : "calc__profile-info_inactive"}`}
                            target="_blank"
                          >Об этом профиле</Link>
                        </div>

                        {
                          /*

                          (
                            <div>
                              <p className="calc__need-name">Выберите тип стеклопакета</p>
                              <div className="calc__choose">
                                <div onClick={() => { rePos(option, 0); }}>
                                  <div className={`calc__choose-dot ${depth === 0 ? "calc__choose-dot_active" : ""}`}></div>
                                  <p>Однокамерный стеклопакет</p>
                                </div>
                                <div onClick={() => { rePos(option, 1); }}>
                                  <div className={`calc__choose-dot ${depth === 1 ? "calc__choose-dot_active" : ""}`}></div>
                                  <p>Двухкамерный стеклопакет</p>
                                </div>
                              </div>
                            </div>
                          )

                          */
                        }

                        <div style={{borderBottom: "2px dashed #D7DFE7", padding: "15px 0 20px"}}>
                          <div className="calc__pars">
                            <label className="calc__label">
                              <p>Ширина:</p>
                              <div className={`calc__select ${isWSOpened ? "calc__select_active" : ""}`} onClick={() => genWSelect()} ref={blockWS}>
                                <p>{data.widths[isWindow][type][option][width]}</p>
                                <ul className="calc__select-block" style={{zIndex: 3}}>
                                  {
                                    data.widths[isWindow][type][option].map((w, i) => {
                                      return ( <li key={i} className="calc__select-option" onClick={() => setWidth(i)}>{w}</li> )
                                    })
                                  }
                                </ul>
                              </div>
                            </label>
                            <label className="calc__label">
                              <p>Высота:</p>
                              <div className={`calc__select ${isHSOpened ? "calc__select_active" : ""}`} onClick={() => genHSelect()} ref={blockHS}>
                                <p>{data.heights[isWindow][type][option][height]}</p>
                                <ul className="calc__select-block" style={{zIndex: 2}}>
                                  {
                                    data.heights[isWindow][type][option].map((h, i) => {
                                      return  (
                                        (priceList2[isWindow][profile][type][option][i][width] !== -1) ? (
                                          <li key={i} className="calc__select-option" onClick={() => setHeight(i)}>{h}</li>
                                        ) : ""
                                      )
                                    })
                                  }
                                </ul>
                              </div>
                            </label>
                          </div>
                        </div>

                        <div className="calc__switches">
                          <div className="calc__adds">
                            {
                              (isWindow) ?
                              (
                                <>
                                  <div className={`calc__add ${type === 5 ? "calc__add_inactive" : ""}`}>
                                    <p>Подоконник</p>
                                    <div style={{display: "flex"}} onClick={() => {if(type !== 5) setIsWindowsill(true)}}>
                                      <div className={`calc__add-dot ${isWindowsill ? "calc__add-dot_active" : ""}`}></div>
                                      <span>Да</span>
                                    </div>
                                    <div style={{display: "flex"}} onClick={() => {if(type !== 5) setIsWindowsill(false)}}>
                                      <div className={`calc__add-dot ${!isWindowsill ? "calc__add-dot_active" : ""}`}></div>
                                      <span>Нет</span>
                                    </div>
                                  </div>

                                  <div className={`calc__add ${type === 5 ? "calc__add_inactive" : ""}`}>
                                    <p>Отлив</p>
                                    <div style={{display: "flex"}} onClick={() => {if(type !== 5) setIsTide(true)}}>
                                      <div className={`calc__add-dot ${isTide ? "calc__add-dot_active" : ""}`}></div>
                                      <span>Да</span>
                                    </div>
                                    <div style={{display: "flex"}} onClick={() => {if(type !== 5) setIsTide(false)}}>
                                      <div className={`calc__add-dot ${!isTide ? "calc__add-dot_active" : ""}`}></div>
                                      <span>Нет</span>
                                    </div>
                                  </div>

                                  <div className={`calc__add`}>
                                    <p>Откосы ПВХ</p>
                                    <div style={{display: "flex"}} onClick={() => setIsSlope(true)}>
                                      <div className={`calc__add-dot ${isSlope ? "calc__add-dot_active" : ""}`}></div>
                                      <span>Да</span>
                                    </div>
                                    <div style={{display: "flex"}} onClick={() => setIsSlope(false)}>
                                      <div className={`calc__add-dot ${!isSlope ? "calc__add-dot_active" : ""}`}></div>
                                      <span>Нет</span>
                                    </div>
                                  </div>
                                </>
                              ) : (<></>)
                            }
                            <div className={`calc__add`}>
                              <p>Монтаж</p>
                              <div style={{display: "flex"}} onClick={() => setIsInstallation(true)}>
                                <div className={`calc__add-dot ${isInstallation ? "calc__add-dot_active" : ""}`}></div>
                                <span>Да</span>
                              </div>
                              <div style={{display: "flex"}} onClick={() => setIsInstallation(false)}>
                                <div className={`calc__add-dot ${!isInstallation ? "calc__add-dot_active" : ""}`}></div>
                                <span>Нет</span>
                              </div>
                            </div>
                          </div>
                          
                          {
                            (isWindow) ? (
                              <div>
                                <p className="calc__chooses-title">Фурнитура</p>
                                <div className="calc__chooses">
                                  <div onClick={() => setArc(0)} className={`calc__choose ${arc === 0 ? "calc__choose_active" : ""}`}><p>KALE</p></div>
                                  <div onClick={() => setArc(1)} className={`calc__choose ${arc === 1 ? "calc__choose_active" : ""}`}><p>ROTO</p></div>
                                  <div className="calc__chooser" style={{marginLeft: `${arc ? "50%" : "0%"}`}}></div>
                                </div>
                              </div>
                            ) : (<></>)
                          }
                        </div>
                          
                        <input
                          option="submit"
                          className={`calc__next-button ${isProfile ? "" : "calc__next-button_inactive"}`}
                          onClick={(event) => { if(isProfile){ event.preventDefault(); setForm(1); } }}
                          defaultValue={"Заказать"}
                          readOnly
                        />
                      </form>
                    </>
                  ) : (
                    <>
                      <div style={{padding: "25px 15px", display: "flex", flexDirection: "column", alignItems: "center"}}>
                        <img src={data.images[isWindow][type][option]} alt="Окно" className="calc__form-img"></img>
                        <p className="calc__now">Оставьте номер своего телефона, наш менеджер свяжется с вами для уточнения деталей</p>
                        <form className="calc__form-user" ref={userRef}>
                          <input type="text" placeholder="Ваше имя"/>
                          <InputMask type="tel" mask="+375 (99) 999-99-99" maskChar="" placeholder="Ваш телефон"/>
                          <input 
                            style={{display: (isSended || messageFailed ? "none" : "block")}} 
                            onClick={(event) => handleSend(event)} defaultValue={"Заказать"}
                            
                            type="submit"
                          />
                          {
                            messageSuccess ? (
                              <>
                                <div id="7373737" className="7373735"><p style={{color: "#50C878"}}>Мы уже получили вашу заявку. Свяжемся с вами в ближайшее время</p></div>
                                <div><p style={{color: "#7C7C7C"}} innerref={timerRef}>Вкладка закроется через 00:0{`${time}`}</p></div>
                              </>
                            ) : (
                              messageFailed ? (
                                <p style={{color: "#EB4C42"}}>Произошла ошибка. Попробуйте ещё раз</p>
                              ) : (<></>)
                            )
                          }
                        </form>
                      </div>
                    </>
                  )
                }
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default App;
